module.exports = __webpack_public_path__ + "img/zain-kuwait.4cbe5ad9.svg";